import { Button } from 'js/components/main/LeaderboardButton/Button';
import { Icon } from 'js/components/common/Icon';
import { withTranslations } from 'js/components/hocs/withTranslations';
import React from 'react';
import { compose, withProps } from 'recompose';
import { registrationStatuses } from '../../constants';
import useJoinLeaveButtonProps from '../useJoinLeaveButtonProps';
import style from './index.scss';

export const JoinButton = ({
                               t,
                               buttonView,
                               disabled,
                               onClick,
                               title,
                               joined,
                               wide = false,
                               className = '',
                               color = 'lbSuccess'
                           }) => (
    <div className={style.container}>
        <Button
            view={buttonView}
            color={color}
            disabled={disabled}
            onClick={onClick}
            className={`${style.join} ${className} ${wide ? style.wide : ''}`}>
            {buttonView === 'readonly' && joined && <Icon type="joined" />}
            {t(title)}
        </Button>
    </div>
);

export default compose(
    withTranslations,
    withProps(({
                   joined,
                   registrationStatus,
                   leaderboardId,
                   nicknameDetails,
                   setJoinAttempted,
                   useTournament,
                   isToUseUsername,
                   fakeState,
                   status,
                   missions,
                   participantsCount,
                   maxParticipantsCount = -1,
                   trackJoinEventClick
               }) => {
        let { disabled, onClick } = useJoinLeaveButtonProps('join')({ leaderboardId, useTournament, style: style.myCustomClassName, trackJoinEventClick, missions });
        if (!joined && !nicknameDetails) {
            disabled = true; // While we wait for the nickname response
        } else if (!joined && nicknameDetails && !nicknameDetails.casinoNickname && !isToUseUsername) {
            // If no nickname is set - override the onClick to say we tried to join so the parent page can render the nickname page
            onClick = () => {
                trackJoinEventClick();
                setJoinAttempted(true);
            };
        }
        let title;
        let buttonView;
        if (missions && fakeState === 'discoveryFinished' && (status === 'PENDING_REVIEW' || status === 'COMPLETED')) {
            title = 'playtech.mobile.casino-leaderboard-page.discoveryFinished';
            buttonView = 'readonly';
        } else if (!missions && fakeState === 'discoveryFinished') {
            title = 'playtech.mobile.casino-leaderboard-page.discoveryFinished';
            buttonView = 'readonly';
        } else if (!joined && maxParticipantsCount === participantsCount) {
            title = useTournament
                ? 'playtech.mobile.casino-leaderboard-page.tournamentFull'
                : 'playtech.mobile.casino-leaderboard-page.leaderboardfull';
            buttonView = 'readonly';
        } else if (missions && (status === 'CANCELLED_BY_ADMIN' || status === 'CANCELLED_DUE_TO_NOT_ENOUGH_PARTICIPANTS')) {
            title = 'playtech.mobile.casino-leaderboard-page.campaign.cancelled';
            buttonView = 'readonly';
        } else if (!joined && registrationStatus === 'FINISHED') {
            title = 'playtech.mobile.casino-leaderboard-page.registrationClosed';
            buttonView = 'readonly';
        } else if (missions) {
            title = `playtech.mobile.system.casino-leaderboard.button.${joined ? 'joined' : 'missionCampaign'}`;
            buttonView = joined ? 'readonly' : 'primary';
        } else {
            title = `playtech.mobile.system.casino-leaderboard.button.${joined ? 'joined' : useTournament ?
                'joinLeaderboard.tournament' : 'joinLeaderboard'}`;
            buttonView = joined ? 'readonly' : 'primary';
        }
        const internalProps = {
            title,
            buttonView,
            fakeState
        };

        return joined
            ? internalProps
            : {
                ...internalProps,
                disabled: registrationStatus === registrationStatuses.NOT_STARTED ||
                    registrationStatus === registrationStatuses.FINISHED || disabled,
                onClick
            };
    })
)(JoinButton);
